import { Link } from 'react-router-dom';

export function DemoBanner() {
  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-3">
            <span className="text-2xl" role="img" aria-label="Demo">
              🎭
            </span>
            <div>
              <p className="font-semibold text-yellow-900">
                DEMO MODE - Viewing Alex Chen's Profile
              </p>
              <p className="text-sm text-yellow-700">
                Explore freely! Changes won't be saved in demo mode.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Link
              to="/demo"
              className="px-4 py-2 text-sm font-medium text-yellow-900 hover:text-yellow-700"
            >
              ← Back to Demos
            </Link>
            <Link
              to="/signup"
              className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 shadow-sm"
            >
              Create Your Own Profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

